var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ViewTemplateWithSalveCancel',{attrs:{"panel":_vm.panel}},[_c('div',{attrs:{"slot":"content-main"},slot:"content-main"},[_c('RentOperationalCreateUpdate',{attrs:{"formName":_vm.panel.formName}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }